import { i18n, isFrenchPath } from "../../internationalize/i18n.service"

const visibleToDisplay = (visible: boolean) => visible ? 'flex' : 'none'

export const setVisible = (element: HTMLElement, visible: boolean) => element.style.display = visibleToDisplay(visible)

export const OTPCodeValidFormat = (OTPCode: number) => OTPCode.toString().length === 6

export const later = (delay: number) => new Promise(resolve => setTimeout(resolve, delay))

export const getPageLanguage = (): "en" | "fr" => {
  const path = window.location.pathname
  // Legacy routes: article-en, report-en
  if (path.includes("article-en") || path.includes("report-en")) return "en"
  return isFrenchPath() ? "fr" : "en"
}

const isCurrentYear = (date: number): boolean => new Date(date).getFullYear() === new Date().getFullYear()
const LONG = { day: '2-digit', month: 'short', year: 'numeric' } as Intl.DateTimeFormatOptions
const SHORT = { day: '2-digit', month: 'short' } as Intl.DateTimeFormatOptions
export const dateLocaleString = (timestamp: number) => new Date(timestamp).toLocaleDateString(i18n.getLocale(), (isCurrentYear(timestamp) ? SHORT : LONG))


export const clickOutside = (e: MouseEvent | PointerEvent) => {
  const rect = (e.target as Element).getBoundingClientRect();
  const collides = (
    rect.top <= e.clientY &&
    e.clientY <= rect.top + rect.height &&
    rect.left <= e.clientX &&
    e.clientX <= rect.left + rect.width
  )
  return !collides
}
